import { render, staticRenderFns } from "./defectsPendingList.vue?vue&type=template&id=233c0610&scoped=true"
import script from "./defectsPendingList.vue?vue&type=script&lang=js"
export * from "./defectsPendingList.vue?vue&type=script&lang=js"
import style0 from "./defectsPendingList.vue?vue&type=style&index=0&id=233c0610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c0610",
  null
  
)

export default component.exports